import React, {useEffect} from 'react';
import {rootActions, useAppDispatch} from "../DAL/store";

import CarouselRightArrowIcon from "../../../../ui/svg/common/carousel-right-arrow";
import CarouselLeftArrowIcon from "../../../../ui/svg/common/carousel-left-arrow";
import {useAppSelector} from "../DAL/store";
import {LoadCaruselLogic} from "../services/carousel";
import {SmartSearchFilterValues} from "../enums";
import {SearchAction} from "../services/logic-helper";

export interface ITopTabsProps {
    setIsLoading: any;
}
const TopTabs = (props:ITopTabsProps) => {
    const dispatch = useAppDispatch();

    const CurrentMainTab = useAppSelector((store) => store.CurrentMainTab);
    const SearchQuery = useAppSelector((store) => store.SearchQuery);


    const SetMainTab = async (tabValue:number) => {
        //if there is no query text:
        // + don't fetch data
        // set URL params
        if(SearchQuery === null || SearchQuery.length === 0){
            dispatch(
                rootActions.main({
                    CurrentMainTab:tabValue,
                    SearchResults:[],
                    CurrentPageNumber:0,
                    TotalNumberOfResults: 0
                })
            );
            let searchParamsUrl = "?";

            searchParamsUrl += "searchtext=&";
            searchParamsUrl += "smartsearchfilter=" + tabValue + "&";
            searchParamsUrl += "page=" + (1);

            let urlWithParams = document.location.pathname + searchParamsUrl;
            window.history.replaceState({}, '', urlWithParams);

            return;
        }
        await SearchAction(SearchQuery,tabValue,0,dispatch,false,props.setIsLoading);

    }
    useEffect(() => {

        LoadCaruselLogic();

    }, []);
    return (
        <div className="w-full">
            <div className="mt-4 md:mt-6 carousel relative" data-carusel-mode="mobile">
                <div className="arr-left py-1 flex items-center h-full z-50" style={{display:"none"}}>

                    <div className="py-2 bg-gray-100 flex justify-center items-center h-full w-full" style={{background:"#F8F9FB"}}>
                        <CarouselLeftArrowIcon width={"17px"} height={"25px"} />
                    </div>

                </div>
                <ul data-carusel="mobile" className="flex flex-wrap carousel-slides" style={{left:0}} id="carouul">
                    <li className="carousel-row" key={"v9"}>
                        <button type="button" onClick={async () => await SetMainTab(SmartSearchFilterValues.AllPages)}
                             className={`${CurrentMainTab === SmartSearchFilterValues.AllPages ? "font-bold border-b-2 md:border-0" : ""} border-gray-700 py-4 px-4 cursor-pointer`}>
                            All Pages
                        </button>
                    </li>
                    <li className="carousel-row" key={"v6"}>
                        <button type="button" onClick={async () => await SetMainTab(SmartSearchFilterValues.Products)}
                             className={`${CurrentMainTab === SmartSearchFilterValues.Products ? "font-bold border-b-2 md:border-0" : ""} border-gray-700 py-4 px-4 cursor-pointer`}>
                            Products
                        </button>
                    </li>
                    <li className="carousel-row" key={"v5"}>
                        <button type="button" onClick={() => SetMainTab(SmartSearchFilterValues.DownloadSupportAccount)}
                             className={`${CurrentMainTab === SmartSearchFilterValues.DownloadSupportAccount ? "font-bold border-b-2 md:border-0" : ""} border-gray-700 py-4 px-4 cursor-pointer`}>
                            Support, Downloads, Account
                        </button>
                    </li>
                    <li className="carousel-row" key={"subscription"}>
                        <button type="button" onClick={() => SetMainTab(SmartSearchFilterValues.VideosBlogposts)}
                             className={`${CurrentMainTab === SmartSearchFilterValues.VideosBlogposts ? "font-bold border-b-2 md:border-0" : ""} border-gray-700 py-4 px-4 cursor-pointer`}>
                            Videos & Blog Posts
                        </button>
                    </li>
                </ul>
                <div className="arr-right py-1 flex justify-center items-center h-full z-50"
                >
                    <div className="py-2 bg-gray-100 flex justify-center items-center h-full w-full">
                        <CarouselRightArrowIcon width={"17px"} height={"25px"} />
                    </div>
                </div>
                <div className="md:hidden w-full border-b border-b-gray-600"></div>
            </div>

        </div>

    )
};

export default TopTabs;